module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00429.c73318fb.jpg";